import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M31,65.6l.3-11.2c0-6.6-.7-11.5-2.1-14.9-1.4-3.4-3.5-5.1-6.3-5.1s-4.4,1.4-6.5,4.1c-.4.5-.9.8-1.1.7-.2-.1,0-.6.2-1.2.9-1.4,2.4-3,4.6-4.5,1.5-1,2.9-1.5,4.4-1.5,3.6,0,6.3,2.1,8.2,6.2,1.6,3.5,2.4,9.2,2.4,17.1v2.3c0,0,9.7-19.7,9.7-19.7l1.8-.5c.2,1.9.5,3.9.8,5.9l.4,2.4c.5,3.1,1,7.5,1.5,13.2l4.1-8c3.1-6.2,4.7-10,4.7-11.7s-.7-1-2.1-1h-.7c-.2-.1-.4-.4-.3-.7,0-.3.3-.4.5-.5h7.9c.2.1.4.4.3.6,0,.3-.3.5-.6.6h-1.7l-13.9,26.8-1.9.5v-2.3c0-7.2-.6-13.7-1.9-19.7l-10.7,21.5-1.9.5Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
